<template>
  <div class="max-w-625 mt-50 md:mt-90 mx-auto text-left">
    <StepContent :theme="theme">
      <div class="sorry">
        <h3 class="text-3xl">
          {{ title }}
        </h3>
        <div>
          <p>
            Sorry, we can't complete your application.
          </p>
          <p>
            We have reviewed your application and unfortunately are unable to approve you for The Foundation at this time. If you have questions please feel free to chat with us
            <a
              :class="textColorClass()"
              @click="triggerChat"
            >
              here
            </a>.
          </p>
        </div>
        <p>
          We appreciate you giving us the opportunity to assist you.
        </p>
        <p>
          - Spring Financial
        </p>
      </div>
    </StepContent>
    <FreshChat
      :load-chat="loadChat"
      @close-chat="loadChat = false"
    />
  </div>
</template>

<script>
import StepContent from '@/components/common/step-layout/StepContent'
import theme from '@/mixins/theme'
import FreshChat from '@/components/widgets/freshchat/FreshChat'
import chatHandler from '@/mixins/freshchat/chat-handler'

export default {
  name: 'Sorry',

  // Components
  components: {
    StepContent,
    FreshChat
  },

  // Mixins
  mixins: [theme, chatHandler],

  // Props
  props: {
    title: {
      type: String,
      default: 'Sorry for the bad news :('
    }
  },

  // Computed
  computed: {
    firstName () {
      return this.$store.state.customer.first_name
    }
  },

  methods: {
    triggerChat () {
      if (window.fcWidget) {
        this.$store.dispatch('setChatStarted', true)
        return window.fcWidget.open()
      }
      this.loadChat = true
    }
  }
}
</script>

<style scoped lang="scss">
.sorry {
  @apply w-auto;

  @screen md {
    @apply w-675;
  }
}

p {
  @apply mt-20 text-base;

  a {
    @apply cursor-pointer;

    font-size: inherit;
  }
}
</style>
